import { render } from "./EmployeeTableRow.vue?vue&type=template&id=7b9b1554"
import script from "./EmployeeTableRow.vue?vue&type=script&lang=ts"
export * from "./EmployeeTableRow.vue?vue&type=script&lang=ts"
script.render = render

export default script